module.exports = __webpack_public_path__ + "static/TFF_Dingo-e4e7ad36c01c4cbffba841b1bd5d3f77.jpg";